import React, { useEffect, useState } from 'react';
import { Col, Nav, NavItem, NavLink } from 'shards-react';
import SidebarMainNavbar from './SidebarMainNavbar';
import SidebarNavItems from './SidebarNavItems';
import TooltipWithArrow from '../../common/TooltipWithArrow';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from '../../../redux/store';
import { cognitoLogout, hasError } from '../../../redux/slices/session';
import getAsyncErrorMessage from '../../../utils/getAsyncErrorMessage';

interface MainSidebarProps {
  hideLogoText: boolean;
}

const MainSidebar = ({ hideLogoText }: MainSidebarProps): React.ReactElement => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const classNames = 'main-sidebar d-flex flex-column justify-content-between px-0 col-12 ';
  const { sidebarOpen } = useSelector((state) => state.session);
  const [sidebarClassNames, setSidebarClassNames] = useState(classNames + (sidebarOpen ? 'open' : ''));

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    setSidebarClassNames(classNames + (sidebarOpen ? 'open' : ''));
  }, [sidebarOpen]);

  // EVENT HANDLER
  // ================================================================================

  const handleLogout = async () => {
    try {
      await dispatch(cognitoLogout());
      history.push('/login');
    } catch (err) {
      const message: string = getAsyncErrorMessage(err);
      dispatch(hasError(message));
    }
  };

  // VIEW
  // ================================================================================

  return (
    <Col tag="aside" className={sidebarClassNames} lg={{ size: 2 }} md={{ size: 3 }}>
      <div className="upper-nav-wrapper">
        <SidebarMainNavbar hideLogoText={hideLogoText} />

        <SidebarNavItems />

        <div className="lower-nav">
          <Nav>
            <TooltipWithArrow id="sidebarNavLogoutTip" title={t('login.logout')}>
              <div id="sidebarNavLogout">
                <NavItem className="nav-logout">
                  <NavLink tag="a" href="#" className="text-danger">
                    <div onClick={handleLogout} className="d-inline-block item-icon-wrapper">
                      <i className="material-icons text-danger">exit_to_app</i>
                    </div>
                    <div className="text-center d-inline-block">
                      <span onClick={handleLogout}>{t('login.logout')}</span>
                    </div>
                  </NavLink>
                </NavItem>
              </div>
            </TooltipWithArrow>
          </Nav>
        </div>
      </div>
    </Col>
  );
};

export default MainSidebar;
